import { render, staticRenderFns } from "./Model25.vue?vue&type=template&id=888fd608&scoped=true"
import script from "./Model25.vue?vue&type=script&lang=js"
export * from "./Model25.vue?vue&type=script&lang=js"
import style0 from "./Model25.vue?vue&type=style&index=0&id=888fd608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888fd608",
  null
  
)

export default component.exports